import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaImages, FaPlay, FaTimes, FaExpandAlt, FaChevronDown, FaVideo, FaCamera } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

const GalleryPage = () => {
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [filter, setFilter] = useState('All');
  const [displayCount, setDisplayCount] = useState(12);

  const BRAND_BLUE = '#3b82f6';
  const DARK_SLATE = '#323d56ff';
  const GOLD = '#fbbf24';

  // --- MANUAL DATA ENTRY SECTION ---
  // Edit the 'category' and 'title' for each item below.
  const videoAssets = [
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463525/WhatsApp_Video_2026-01-14_at_2.45.43_PM_klopv0.mp4", category: "Construction", title: "Excavation Works" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463525/WhatsApp_Video_2026-01-14_at_2.52.26_PM_okmqvv.mp4", category: "Manpower", title: "Safety Briefing" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463520/WhatsApp_Video_2026-01-14_at_2.35.48_PM_gofmc4.mp4", category: "MEP", title: "Pipe Installation" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463520/WhatsApp_Video_2026-01-14_at_2.33.49_PM_dxdrhh.mp4", category: "Industrial", title: "Facility Walkthrough" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463519/WhatsApp_Video_2026-01-14_at_2.35.42_PM_wqfv9p.mp4", category: "Construction", title: "Civil Progress" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463519/WhatsApp_Video_2026-01-14_at_2.09.56_PM_wglzi2.mp4", category: "MEP", title: "Electrical Testing" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463518/WhatsApp_Video_2026-01-14_at_2.33.48_PM_rbzcat.mp4", category: "Construction", title: "Site Foundation" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463518/WhatsApp_Video_2026-01-14_at_2.33.38_PM_h70k6a.mp4", category: "Industrial", title: "Coating Process" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463518/WhatsApp_Video_2026-01-14_at_2.33.33_PM_apshhu.mp4", category: "Industrial", title: "Sand Blasting" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463518/WhatsApp_Video_2026-01-14_at_2.32.27_PM_yo2ehh.mp4", category: "Construction", title: "Structural Steel" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463517/WhatsApp_Video_2026-01-14_at_2.30.47_PM_dv0h0z.mp4", category: "Manpower", title: "Labor Deployment" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463516/WhatsApp_Video_2026-01-14_at_2.08.10_PM_cfttnf.mp4", category: "MEP", title: "HVAC Maintenance" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463515/WhatsApp_Video_2026-01-14_at_2.08.58_PM_ovsmly.mp4", category: "MEP", title: "Ducting Work" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463513/WhatsApp_Video_2026-01-14_at_1.58.27_PM_efu6zj.mp4", category: "Construction", title: "Casting Phase" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463513/WhatsApp_Video_2026-01-14_at_1.58.26_PM_i5aevo.mp4", category: "Construction", title: "Heavy Machinery" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463513/WhatsApp_Video_2026-01-14_at_1.58.25_PM_xcmbu3.mp4", category: "Construction", title: "Site Overview" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463513/WhatsApp_Video_2026-01-14_at_1.58.24_PM_uq8gow.mp4", category: "Construction", title: "Day Shift Operations" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768656274/Vdo1_d8aj2o.mp4", category: "Construction", title: "Day Shift Operations" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768656259/Vdo_w3whuy.mp4", category: "Construction", title: "Day Shift Operations" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768463513/WhatsApp_Video_2026-01-14_at_1.58.24_PM_uq8gow.mp4", category: "Construction", title: "Day Shift Operations" },
    { url: "https://res.cloudinary.com/dfdu54hxs/video/upload/v1768656272/Video_utpmcp.mp4", category: "Construction", title: "Day Shift Operations" }


  ];


  const imageAssets = [
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463495/WhatsApp_Image_2026-01-14_at_2.52.11_PM_1_c5guje.jpg", category: "Construction", title: "Project Site A" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463495/WhatsApp_Image_2026-01-14_at_2.52.09_PM_zg55mj.jpg", category: "Manpower", title: "Skilled Team" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463495/WhatsApp_Image_2026-01-14_at_2.52.09_PM_1_c5jd2j.jpg", category: "Industrial", title: "Surface Protection" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463494/WhatsApp_Image_2026-01-14_at_2.48.56_PM_jj5xvr.jpg", category: "MEP", title: "System Wiring" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463494/WhatsApp_Image_2026-01-14_at_2.48.56_PM_1_jwlqd8.jpg", category: "MEP", title: "Panel Board" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463492/WhatsApp_Image_2026-01-14_at_2.48.55_PM_arwica.jpg", category: "Industrial", title: "Scaffolding" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463492/WhatsApp_Image_2026-01-14_at_2.48.55_PM_1_jrf0yh.jpg", category: "Construction", title: "Wall Finishing" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463491/WhatsApp_Image_2026-01-14_at_2.48.11_PM_gcpx3k.jpg", category: "Manpower", title: "Engineers" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463491/WhatsApp_Image_2026-01-14_at_2.48.11_PM_1_vemfa8.jpg", category: "Construction", title: "Site Inspection" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463491/WhatsApp_Image_2026-01-14_at_2.48.10_PM_hkaxxs.jpg", category: "MEP", title: "HVAC Unit" },

    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463489/WhatsApp_Image_2026-01-14_at_2.48.10_PM_2_g3bshe.jpg", category: "Construction", title: "Brick Work" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463488/WhatsApp_Image_2026-01-14_at_2.48.10_PM_1_qokvtb.jpg", category: "Construction", title: "External View" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463488/WhatsApp_Image_2026-01-14_at_2.47.37_PM_yxavzc.jpg", category: "Industrial", title: "Corrosion Control" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463488/WhatsApp_Image_2026-01-14_at_2.47.37_PM_1_w7vbl2.jpg", category: "Construction", title: "Foundation Prep" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463487/WhatsApp_Image_2026-01-14_at_2.47.36_PM_k45d1p.jpg", category: "Construction", title: "Rebar Work" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463486/WhatsApp_Image_2026-01-14_at_2.47.36_PM_2_rlvprb.jpg", category: "Industrial", title: "Tank Lining" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463485/WhatsApp_Image_2026-01-14_at_2.47.36_PM_1_tbongh.jpg", category: "Construction", title: "Leveling Work" },

    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463484/WhatsApp_Image_2026-01-14_at_2.03.29_PM_tvagyc.jpg", category: "Manpower", title: "Team Meeting" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463484/WhatsApp_Image_2026-01-14_at_2.04.17_PM_xip5ct.jpg", category: "MEP", title: "Plumbing Installation" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463484/WhatsApp_Image_2026-01-14_at_2.02.22_PM_pqsilh.jpg", category: "Construction", title: "Interlock Work" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463483/WhatsApp_Image_2026-01-14_at_2.02.22_PM_1_clka3v.jpg", category: "Construction", title: "Daily Operations" },

    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463512/WhatsApp_Image_2026-01-15_at_8.26.28_AM_ewupnh.jpg", category: "Manpower", title: "Safety Gear" },

    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463509/WhatsApp_Image_2026-01-14_at_2.52.25_PM_vogreb.jpg", category: "Construction", title: "Project Block C" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463509/WhatsApp_Image_2026-01-14_at_2.52.18_PM_d5vfz8.jpg", category: "Construction", title: "Project Block D" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463508/WhatsApp_Image_2026-01-14_at_2.52.17_PM_ephb8f.jpg", category: "Industrial", title: "Piping Network" },
    // MISSING IMAGES — append to imageAssets

    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463481/WhatsApp_Image_2026-01-14_at_2.02.21_PM_xy0rcl.jpg", category: "Construction", title: "Site Snapshot" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463481/WhatsApp_Image_2026-01-14_at_2.02.21_PM_2_o6tiys.jpg", category: "Construction", title: "Work Progress" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463481/WhatsApp_Image_2026-01-14_at_2.02.21_PM_3_qmtluv.jpg", category: "Construction", title: "Onsite Activity" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463481/WhatsApp_Image_2026-01-14_at_2.02.21_PM_4_mou1l4.jpg", category: "Construction", title: "Foundation Check" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463481/WhatsApp_Image_2026-01-14_at_2.02.21_PM_5_b1zz0f.jpg", category: "Construction", title: "Structural Stage" },

    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463480/WhatsApp_Image_2026-01-14_at_2.02.20_PM_d7ycm9.jpg", category: "Construction", title: "Site Alignment" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463480/WhatsApp_Image_2026-01-14_at_2.02.21_PM_1_zuzknc.jpg", category: "Construction", title: "Survey Work" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463480/WhatsApp_Image_2026-01-14_at_2.02.20_PM_1_eckfm8.jpg", category: "Construction", title: "Base Preparation" },

    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463480/WhatsApp_Image_2026-01-14_at_2.02.17_PM_q44wme.jpg", category: "MEP", title: "Electrical Routing" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463480/WhatsApp_Image_2026-01-14_at_2.02.17_PM_1_uleius.jpg", category: "MEP", title: "Cable Tray Work" },

    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463479/WhatsApp_Image_2026-01-14_at_2.02.16_PM_hb6xij.jpg", category: "Industrial", title: "Industrial Coating" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463479/WhatsApp_Image_2026-01-14_at_2.02.15_PM_1_fd1n8h.jpg", category: "Industrial", title: "Surface Prep" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463479/WhatsApp_Image_2026-01-14_at_2.02.14_PM_jnpvcy.jpg", category: "Industrial", title: "Protective Layer" },

    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463478/WhatsApp_Image_2026-01-14_at_2.02.16_PM_2_mbjuif.jpg", category: "Construction", title: "Final Touches" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463478/WhatsApp_Image_2026-01-14_at_2.00.48_PM_2_fjd3dp.jpg", category: "Construction", title: "Ground Work" },

    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463525/WhatsApp_Image_2026-01-14_at_2.00.45_PM_pgdeio.jpg", category: "Manpower", title: "Worker Briefing" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463525/WhatsApp_Image_2026-01-14_at_2.00.46_PM_ffglwl.jpg", category: "Manpower", title: "Safety Compliance" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463525/WhatsApp_Image_2026-01-14_at_2.00.47_PM_h59jkj.jpg", category: "Manpower", title: "PPE Check" },

    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463508/WhatsApp_Image_2026-01-14_at_2.52.17_PM_2_dl05sw.jpg", category: "Industrial", title: "Pipe Assembly" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463505/WhatsApp_Image_2026-01-14_at_2.52.17_PM_1_epdire.jpg", category: "Industrial", title: "Valve Section" },

    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463505/WhatsApp_Image_2026-01-14_at_2.52.16_PM_ngo0nn.jpg", category: "Construction", title: "Concrete Finish" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463505/WhatsApp_Image_2026-01-14_at_2.52.15_PM_agyvok.jpg", category: "Construction", title: "Surface Leveling" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463505/WhatsApp_Image_2026-01-14_at_2.52.15_PM_1_eesuup.jpg", category: "Construction", title: "Final Layer" },

    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463504/WhatsApp_Image_2026-01-14_at_2.52.14_PM_ujviey.jpg", category: "Construction", title: "Site Closeup" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463502/WhatsApp_Image_2026-01-14_at_2.52.14_PM_1_tywsfy.jpg", category: "Construction", title: "Finishing Stage" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463502/WhatsApp_Image_2026-01-14_at_2.52.13_PM_ze11yq.jpg", category: "Construction", title: "Structure Detail" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463502/WhatsApp_Image_2026-01-14_at_2.52.13_PM_1_flbmph.jpg", category: "Construction", title: "Work Detail" },

    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463501/WhatsApp_Image_2026-01-14_at_2.52.12_PM_c5dbvg.jpg", category: "Construction", title: "Final Inspection" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463499/WhatsApp_Image_2026-01-14_at_2.52.12_PM_3_nu9lp9.jpg", category: "Construction", title: "Handover Prep" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463498/WhatsApp_Image_2026-01-14_at_2.52.12_PM_2_d1qaut.jpg", category: "Construction", title: "Site Cleanup" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463498/WhatsApp_Image_2026-01-14_at_2.52.12_PM_1_yfyekq.jpg", category: "Construction", title: "Completion View" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463498/WhatsApp_Image_2026-01-14_at_2.52.11_PM_vuhesc.jpg", category: "Construction", title: "Final Shot" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463497/WhatsApp_Image_2026-01-14_at_2.52.11_PM_2_rt7ifz.jpg", category: "Construction", title: "Project Closure" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656269/WhatsApp_Image_2026-01-16_at_3.27.23_PM_w7hp67.jpg", category: "Construction", title: "Project Image 1" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656269/WhatsApp_Image_2026-01-16_at_3.27.24_PM_1_irb9zz.jpg", category: "Construction", title: "Project Image 2" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656268/WhatsApp_Image_2026-01-16_at_3.27.22_PM_txzlzx.jpg", category: "Construction", title: "Project Image 3" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656266/WhatsApp_Image_2026-01-15_at_5.53.46_PM_abx5my.jpg", category: "Construction", title: "Project Image 4" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656265/WhatsApp_Image_2026-01-15_at_4.35.34_PM_xlb5af.jpg", category: "Construction", title: "Project Image 5" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656264/WhatsApp_Image_2026-01-15_at_4.35.33_PM_lbjkw0.jpg", category: "Construction", title: "Project Image 6" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656262/WhatsApp_Image_2026-01-15_at_4.24.34_PM_mtbtjs.jpg", category: "Construction", title: "Project Image 7" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656261/WhatsApp_Image_2026-01-15_at_4.24.34_PM_1_c1rfat.jpg", category: "Construction", title: "Project Image 8" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656262/WhatsApp_Image_2026-01-15_at_1.42.32_PM_avsmhe.jpg", category: "Construction", title: "Project Image 9" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656259/WhatsApp_Image_2026-01-17_at_11.09.15_AM_uh161m.jpg", category: "Construction", title: "Project Image 10" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656258/WhatsApp_Image_2026-01-17_at_11.09.16_AM_gwggsv.jpg", category: "Construction", title: "Project Image 11" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656257/WhatsApp_Image_2026-01-17_at_11.09.14_AM_w5itso.jpg", category: "Construction", title: "Project Image 12" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656257/WhatsApp_Image_2026-01-17_at_8.40.32_AM_wyjejg.jpg", category: "Construction", title: "Project Image 13" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656257/WhatsApp_Image_2026-01-16_at_3.27.24_PM_gzqgwr.jpg", category: "Construction", title: "Project Image 14" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656257/WhatsApp_Image_2026-01-17_at_10.55.18_AM_1_s40c1i.jpg", category: "Construction", title: "Project Image 15" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768656257/WhatsApp_Image_2026-01-17_at_10.55.18_AM_e8rwxf.jpg", category: "Construction", title: "Project Image 16" },
    { url: "https://res.cloudinary.com/dfdu54hxs/image/upload/v1768463478/WhatsApp_Image_2026-01-14_at_2.02.13_PM_1_z1expy.jpg", category: "Construction", title: "Project Completion" }
  ];


  // Combine them into a single list
  const galleryData = [
    ...videoAssets.map((v, i) => ({ id: `v-${i}`, type: 'video', ...v })),
    ...imageAssets.map((img, i) => ({ id: `i-${i}`, type: 'image', ...img }))
  ];

  const filters = ['All', 'Videos', 'Photos',];

  const filteredMedia = galleryData.filter(item => {
    if (filter === 'All') return true;
    if (filter === 'Videos') return item.type === 'video';
    if (filter === 'Photos') return item.type === 'image';
    return item.category === filter;
  });

  const shownMedia = filteredMedia.slice(0, displayCount);

  return (
    <div style={{ background: '#f8fafc', minHeight: '100vh', paddingBottom: '80px' }}>
      <Helmet>
        <title>
          Construction Projects Gallery Qatar | Manpower & Civil Works Photos
        </title>

        <meta
          name="description"
          content="Browse our construction project gallery in Qatar. Real images and videos showcasing civil works, industrial projects, skilled manpower supply, subcontracting, MEP works, and site execution across Doha, Lusail, and Qatar."
        />

        <link rel="canonical" href="https://abrajaldhafna.com/gallery" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebSite",
                "@id": "https://abrajaldhafna.com/#website",
                "url": "https://abrajaldhafna.com/",
                "name": "Abraj Al Dhafna Trading & Contracting WLL",
                "publisher": {
                  "@id": "https://abrajaldhafna.com/#organization"
                }
              },
              {
                "@type": "Organization",
                "@id": "https://abrajaldhafna.com/#organization",
                "name": "Abraj Al Dhafna Trading & Contracting WLL",
                "url": "https://abrajaldhafna.com/",
                "logo": "https://abrajaldhafna.com/logo.jpeg",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Doha",
                  "addressCountry": "QA"
                }
              },
              {
                "@type": "CollectionPage",
                "@id": "https://abrajaldhafna.com/gallery#collection",
                "url": "https://abrajaldhafna.com/gallery",
                "name": "Construction Project Gallery Qatar",
                "description": "Visual gallery of construction subcontracting, manpower supply, civil works, industrial services, and MEP projects delivered across Qatar.",
                "isPartOf": {
                  "@id": "https://abrajaldhafna.com/#website"
                },
                "about": {
                  "@id": "https://abrajaldhafna.com/#organization"
                }
              },
              {
                "@type": "ImageGallery",
                "@id": "https://abrajaldhafna.com/gallery#media",
                "name": "Construction Project Media Gallery",
                "associatedMedia": filteredMedia.map(item => ({
                  "@type": item.type === "video" ? "VideoObject" : "ImageObject",
                  "contentUrl": item.url,
                  "name": item.title || "Construction Project Media",
                  "description": item.category
                    ? `Construction ${item.category} work in Qatar`
                    : "Construction project media in Qatar",
                  "uploadDate": item.date || "2024-01-01"
                }))
              },
              {
                "@type": "BreadcrumbList",
                "@id": "https://abrajaldhafna.com/gallery#breadcrumb",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://abrajaldhafna.com/"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Gallery",
                    "item": "https://abrajaldhafna.com/gallery"
                  }
                ]
              }
            ]
          })}
        </script>
      </Helmet>
      <section aria-hidden="true" style={{ position: "absolute", left: "-9999px" }}>
        <h1>Construction Project Gallery in Qatar</h1>
        <p>
          This gallery showcases real construction projects delivered by Abraj Al Dhafna
          Trading & Contracting WLL across Qatar, including civil works, industrial
          services, manpower supply, MEP subcontracting, and site execution in Doha,
          Lusail, West Bay, and industrial zones.
        </p>
      </section>

      {/* --- HERO --- */}
      <section style={styles.hero}>
        <div style={styles.container}>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} style={{ textAlign: 'center' }}>
            <div style={styles.badge}><FaImages /> PROJECT SHOWCASE</div>
            <h1 style={styles.heroTitle}>Our <span style={{ color: GOLD }}>Media</span></h1>
            <p style={styles.heroSubtitle}>Accurate visual records of our civil and industrial expertise in Qatar.</p>
          </motion.div>
        </div>
      </section>

      {/* --- FILTER --- */}
      <div style={styles.filterBar}>
        <div style={styles.container}>
          <div style={styles.filterWrapper}>
            {filters.map(f => (
              <button key={f} onClick={() => { setFilter(f); setDisplayCount(12); }}
                style={{
                  ...styles.filterBtn,
                  background: filter === f ? BRAND_BLUE : '#fff',
                  color: filter === f ? '#fff' : DARK_SLATE,
                  boxShadow: filter === f ? `0 4px 12px ${BRAND_BLUE}40` : 'none'
                }}
              >
                {f}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* --- GRID --- */}
      <section style={{ padding: '0 20px' }}>
        <div style={styles.container}>
          <motion.div layout style={styles.grid}>
            <AnimatePresence mode='popLayout'>
              {shownMedia.map((item) => (
                <motion.div layout key={item.id} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                  whileHover={{ y: -5 }} onClick={() => setSelectedMedia(item)} style={styles.card}
                >
                  <div style={styles.imageContainer}>
                    {item.type === 'video' ? (
                      <div style={styles.videoThumbnail}>
                        <video src={item.url} style={styles.image} muted />
                        <div style={styles.playOverlay}><FaPlay size={24} color="#fff" /></div>
                      </div>
                    ) : (
                      <img src={item.url} alt={item.title} style={styles.image} loading="lazy" />
                    )}
                  </div>
                  {/* <div style={styles.cardInfo}>
                    <span style={{...styles.cardCat, color: BRAND_BLUE}}>{item.category}</span>
                    <h4 style={styles.cardTitle}>{item.title}</h4>
                  </div> */}
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>

          {displayCount < filteredMedia.length && (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
              <button onClick={() => setDisplayCount(prev => prev + 12)} style={styles.loadMoreBtn}>
                <FaChevronDown style={{ marginRight: '8px' }} /> Show More
              </button>
            </div>
          )}
        </div>
      </section>

      {/* --- LIGHTBOX --- */}
      <AnimatePresence>
        {selectedMedia && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            style={styles.lightboxOverlay} onClick={() => setSelectedMedia(null)}
          >
            <button style={styles.closeBtn} onClick={() => setSelectedMedia(null)}><FaTimes /></button>
            <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
              {selectedMedia.type === 'video' ? (
                <video src={selectedMedia.url} controls autoPlay style={styles.lightboxMedia} />
              ) : (
                <img src={selectedMedia.url} style={styles.lightboxMedia} alt="Project" />
              )}
              {/* <div style={{marginTop: '15px', color: '#fff'}}>
                <h3 style={{color: GOLD}}>{selectedMedia.title}</h3>
                <p>{selectedMedia.category}</p>
              </div> */}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const styles = {
  container: { maxWidth: '1200px', margin: '0 auto' },
  hero: { background: '#323d56ff', padding: '100px 20px 80px', color: '#fff', clipPath: 'polygon(0 0, 100% 0, 100% 90%, 0% 100%)' },
  heroTitle: { fontSize: '3rem', fontWeight: '900' },
  heroSubtitle: { opacity: 0.8, marginTop: '10px' },
  badge: { display: 'inline-block', background: 'rgba(255,255,255,0.1)', padding: '5px 15px', borderRadius: '50px', fontSize: '12px', color: '#fbbf24', marginBottom: '15px' },
  filterBar: { marginTop: '-30px', marginBottom: '40px', padding: '0 20px' },
  filterWrapper: { display: 'flex', gap: '10px', overflowX: 'auto', padding: '10px 0' },
  filterBtn: { padding: '10px 25px', borderRadius: '50px', border: '1px solid #e2e8f0', fontWeight: '700', cursor: 'pointer', whiteSpace: 'nowrap' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '25px' },
  card: { background: '#fff', borderRadius: '15px', overflow: 'hidden', cursor: 'pointer', boxShadow: '0 10px 20px rgba(0,0,0,0.05)' },
  imageContainer: { position: 'relative', height: '220px', background: '#000' },
  image: { width: '100%', height: '100%', objectFit: 'cover' },
  videoThumbnail: { position: 'relative', height: '100%' },
  playOverlay: { position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.2)' },
  cardInfo: { padding: '15px' },
  cardCat: { fontSize: '10px', fontWeight: '800', textTransform: 'uppercase' },
  cardTitle: { fontSize: '16px', fontWeight: '700', color: '#1e293b', marginTop: '4px' },
  loadMoreBtn: { background: '#323d56ff', color: '#fff', padding: '14px 40px', borderRadius: '50px', border: 'none', fontWeight: '700', cursor: 'pointer' },
  lightboxOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.95)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
  modalContent: { maxWidth: '1000px', width: '100%', textAlign: 'center' },
  lightboxMedia: { maxWidth: '100%', maxHeight: '75vh', borderRadius: '8px' },
  closeBtn: { position: 'absolute', top: '25px', right: '25px', background: '#fff', border: 'none', borderRadius: '50%', padding: '10px', cursor: 'pointer' }
};

export default GalleryPage;